
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { JobDocumentsContext } from 'stores/JobDocumentsStore'
import Button from 'components/common/Button'
import * as S from "./styles"

export const DeleteJobModal = ({ show, data: { id, rig, jobDate }, close, closeAndUpdate, ...props }) => {

  const { isLoading, deleteJob } = useContext(JobDocumentsContext)

  const { t } = useTranslation()

  const handleDeleteJob = async () => {
    const response = await deleteJob(id)

    if (response.error) {
      toast.error(response.error)
    } else {
      toast.success(`${rig} deleted.`)
    };

    await closeAndUpdate({ success: response.error ? false : true })
  }

  if (!show) return null

  return (
    <S.BlackGlass>
      <S.ConfirmationModal>
        <h1 style={{ fontWeight: 400, fontSize: "18px", textAlign: "center" }}>{t('upload.delete')} {rig} {jobDate}  ?</h1>
        {isLoading ? (
          <p style={{ fontSize: "16px", color: "grey", textAlign: "center" }}> Removing... </p>
        ) : (
          <div style={{
            display: "flex",
            justifyContent: "center"
          }}>
            <Button alignSelf="flex-end" backgroundColor="primary" color="white" fontSize="big" onClick={handleDeleteJob}>
              {t('upload.delete')}
            </Button>
            <Button alignSelf="flex-end" backgroundColor="grey" color="white" fontSize="big" onClick={() => close()}>
              {t('upload.cancel')}
            </Button>
          </div>
        )}
      </S.ConfirmationModal>
    </S.BlackGlass>
  )
}